module.exports = __webpack_public_path__ + "img/score_item_on.df14762f.svg";